import React, { useState } from "react";
import { mapTableRows } from "../../../../utils";
import {
  Backdrop,
  FormFieldSet,
  LogoLoader,
  StatusTags,
  TableAdv,
} from "../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getProspectsStart } from "../../../../redux/slices/leads/leadsSlice";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { formatWords2 } from "../../../../utils/stringUtils";
import { getEndOfDay, getStartOfDay } from "../../../../utils/common";
import dayjs from "dayjs";
const AllProspects = () => {
  const { userData: loginUserData } = useLoginUser();
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { }
  );
  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.prospectsCounts?.data || 0;
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState(new Date());
  // new Date()
  const [toDate, setToDate] = useState(new Date());
  // new Date()
  const [jobStatus, setJobStatus] = useState([]);
  const [raNameFilter, setRaNameFilter] = useState([]);
  const prospectsData = useSelector(
    (state) => state.leads.prospects.data || []
  );
  const loading = useSelector((state) => state.leads.loading);
  const userRoleType = loginUserData?.role?.type;
  const level = loginUserData?.level;
  const columns = [
    // {
    //   key: "pId",
    //   label: "ID",
    //   render: (row) => <div className="text-info">{row.id}</div>,
    // },
    {
      key: "raName",
      label: "RA Name",
      width: "min-w-[150px]! max-w-[250px]!"
    },
    {
      key: "clientName",
      label: "Client Name",
      width: "min-w-[200px]! max-w-[250px]!"
    },
    {
      key: "jobPosition",
      label: "Job Position",
      width: "min-w-[250px]! max-w-[300px]!"
    },
    {
      key: "jobLocation",
      label: "Job Location",
      width: "min-w-[200px]! max-w-[250px]!"
    },
    {
      key: "bdmName",
      label: "BDM Name",
      width: "min-w-[200px]! max-w-[250px]!"
    },
    {
      key: "bdmResponseDate",
      label: "BDM Response Date",
      width: "min-w-[200px]! max-w-[250px]!"
    },
    {
      key: "leadDate",
      label: "Lead Date",
      width: "min-w-[200px]! max-w-[250px]!"
    },
    {
      key: "jobStatus",
      label: "Job Status",
      render: (row) => {
        return (
          <StatusTags
            tag={row.jobStatus}
            className={
              row.jobStatus === "Closed"
                ? " !bg-danger-500 text-white"
                : "bg-success-500 text-white"
            }
          />
        );
      },
    },
  ];

  const JobStatus = {
    1: "Active",
    2: "Positive",
    3: "Open",
    4: "On Hold", // job posting status
    5: "Hold by Client",
    6: "Interview L1",
    7: "Interview L2",
    8: "Interview L3",
    9: "Priority",
    10: "Filled",
    11: "Closed",
    12: "Agreement Sent",
    13: "Agreement Accepted",
  };

  const mappedRows = mapTableRows(
    prospectsData.map((item, index) => {
      return {
        id: item?._id || index + 1,
        raName: formatWords2(item.addedBy?.firstName),
        clientName: formatWords2(item.companyId?.name),
        jobPosition: formatWords2(item.title),
        // jobLocation: `${item.location?.city || ""}, ${
        //   item.location?.state || ""
        // }`,
        jobLocation: [item.location?.city, item.location?.state]
          .filter(Boolean)
          .join(", "),
        bdmName: formatWords2(item.modifiedBy?.firstName),
        // bdmResponseDate: item.modifiedOn,
        // leadDate: item.addedOn,
        bdmResponseDate: convertFromUTC(item.modifiedOn),
        leadDate: convertFromUTC(item.addedOn),
        jobStatus: JobStatus[item.status] || "Unknown",
      };
    }),
    columns
  );

  useEffect(() => {
    let filters = { modifiedBy: { type: "EXISTS", value: true } };
    if (userRoleType !== 1 && level !== 5) {
      filters.addedBy = {
        type: "NONE",
        value: userRoleType !== 1 && level !== 5 ? loginUserData?.uiid : "",
      };
    }
    if (fromDate && toDate) {
      filters = {
        ...filters,
        modifiedOn: {
          type: "DATE_RANGE",
          value: {
            // from: dayjs(fromDate).startOf("day").toISOString(),
            // to: dayjs(toDate).endOf("day").toISOString(),
            from: getStartOfDay(fromDate),
            to: getEndOfDay(toDate),
          },
        },
      };
    }
    if (jobStatus && jobStatus.length > 0) {
      filters.status = {
        type: "IN",
        value: jobStatus,
      };
    }
    dispatch(
      totalCountStart({
        collection: "jobs",
        coll: "Job",
        tname: "prospectsCounts",
        filters: filters,
        app: "ats",
      })
    );
    const action = {
      coll: "Job",
      lim: limit,
      pg: page,
      ret: "uiid title addedBy addedOn companyId location status description modifiedBy modifiedOn",
      ref: "Company",
      fil: JSON.stringify(filters),
      extret: "uiid firstName",
      incl: ["name"],
      useAggregate: false,
      sort: JSON.stringify({ modifiedOn: -1 }),
    };
    dispatch(getProspectsStart(action));
  }, [dispatch, page, limit, fromDate, toDate, jobStatus]);

  const filterRows = React.useMemo(() => {
    if (!raNameFilter || raNameFilter.length === 0) return mappedRows;
    return (mappedRows ?? []).filter(
      (row) => raNameFilter.includes(row?.raName)
    );
  }, [mappedRows, raNameFilter]);


  return (
    <div className="flex-1 flex overflow-auto">
      <TableAdv
        tableId={"RAAllProspectsTable"}
        showCheckbox
        columns={columns}
        rows={filterRows}
        serverPagination={true}
        totalCount={totalCount}
        page={page}
        showSlNo
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        info={"info"}
        tdClassName="!py-3"
        toolbarRight={{
          filter: true,
          add: [
            {
              component: (
                <>
                  <div className="min-w-[200px]">
                    <FormFieldSet
                      type="select"
                      noTitle
                      placeholder="Search RA "
                      size="sm"
                      multiple
                      options={[
                        ...new Set(
                          (mappedRows ?? [])
                            .map(row => row?.raName)
                            .filter(Boolean)
                        )
                      ].map(name => ({
                        label: name,
                        value: name
                      }))}
                      value={raNameFilter}
                      showSearch
                      onChange={(value) => setRaNameFilter(value)}
                    // showButton
                    />
                  </div>
                  <FormFieldSet
                    noTitle
                    placeholder="Select date range"
                    type="datepickerRange"
                    size="sm"
                    value={{
                      from: fromDate,
                      to: toDate,
                    }}
                    onChange={(range) => {
                      if (range?.from && range?.to) {
                        setFromDate(dayjs(range.from).format("YYYY-MM-DD"));
                        setToDate(dayjs(range.to).format("YYYY-MM-DD"));
                      }
                    }}
                  />
                  <div className="min-w-[200px]">
                    <FormFieldSet
                      type="select"
                      placeholder="Select"
                      noTitle
                      size="sm"
                      multiple
                      options={[
                        { label: "Active", value: 1 },
                        { label: "Positive", value: 2 },
                        { label: "Open", value: 3 },
                        { label: "On Hold", value: 4 },
                        { label: "Hold by Client", value: 5 },
                        { label: "Interview L1", value: 6 },
                        { label: "Interview L2", value: 7 },
                        { label: "Interview L3", value: 8 },
                        { label: "Priority", value: 9 },
                        { label: "Filled", value: 10 },
                        { label: "Closed", value: 11 },
                        { label: "Agreement Sent", value: 12 },
                        { label: "Agreement Accepted", value: 13 },
                      ]}
                      value={jobStatus}
                      onChange={(value) => setJobStatus(value)}
                    />

                  </div>
                </>
              ),
            },
          ],
          order: ["add", "filter"],
        }}

      />


      <Backdrop isOpen={loading} zIndex={59}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default AllProspects;
